// This file is generated by icon spritesheet generator

export const iconNames = [
  "zhipuai",
  "zhipuai-coding-plan",
  "zenmux",
  "zai",
  "zai-coding-plan",
  "xiaomi",
  "xai",
  "wandb",
  "vultr",
  "vivgrid",
  "vercel",
  "venice",
  "v0",
  "upstage",
  "togetherai",
  "synthetic",
  "submodel",
  "stepfun",
  "stackit",
  "siliconflow",
  "siliconflow-cn",
  "scaleway",
  "sap-ai-core",
  "requesty",
  "qiniu-ai",
  "qihang-ai",
  "privatemode-ai",
  "poe",
  "perplexity",
  "ovhcloud",
  "openrouter",
  "llmgateway",
  "opencode",
  "opencode-go",
  "openai",
  "ollama-cloud",
  "nvidia",
  "novita-ai",
  "nova",
  "nebius",
  "nano-gpt",
  "morph",
  "moonshotai",
  "moonshotai-cn",
  "modelscope",
  "moark",
  "mistral",
  "minimax",
  "minimax-coding-plan",
  "minimax-cn",
  "minimax-cn-coding-plan",
  "meganova",
  "lucidquery",
  "lmstudio",
  "llama",
  "kuae-cloud-coding-plan",
  "kimi-for-coding",
  "kilo",
  "jiekou",
  "io-net",
  "inference",
  "inception",
  "iflowcn",
  "huggingface",
  "helicone",
  "groq",
  "google",
  "google-vertex",
  "google-vertex-anthropic",
  "gitlab",
  "github-models",
  "github-copilot",
  "friendli",
  "firmware",
  "fireworks-ai",
  "fastrouter",
  "evroc",
  "digitalocean",
  "deepseek",
  "deepinfra",
  "cortecs",
  "cohere",
  "cloudflare-workers-ai",
  "cloudflare-ai-gateway",
  "cloudferro-sherlock",
  "chutes",
  "cerebras",
  "berget",
  "baseten",
  "bailing",
  "azure",
  "azure-cognitive-services",
  "anthropic",
  "amazon-bedrock",
  "alibaba",
  "alibaba-cn",
  "aihubmix",
  "abacus",
  "302ai",
] as const

export type IconName = (typeof iconNames)[number]
